<template>
  <div class="clearance-stock">
    <shape-head-image-component
      class="clearance-stock__image"
      desktop_src="/images/page_data/clearance-thumb.jpg"
      desktop_src_lazy="/images/page_data/clearance.jpg"
      mobile_src="/images/page_data/clearance-thumb.jpg"
      mobile_src_lazy="/images/page_data/clearance.jpg"
      cover_img
      hide_shape
    />
    <div class="container">
      <div class="clearance-stock__pull-right">
        <div class="clearance-stock__description">
          <default-title
            :title="title"
            :title_tag="title_tag"
          />
          <html-block
            v-if="content"
            class="mt-10"
            :content="content"
          />
        </div>
        <form class="clearance-stock-form" @submit.prevent="sendClearanceStock">
          <div class="row gap-15 mt-30">
            <div class="col-12 col-sm-6">
              <default-input
                v-model="stock.company_name"
                :placeholder="$t('input_placeholder.company_name')"
                name="company_name"
                required
                maxlength="150"
              />
            </div>
            <div class="col-12 col-sm-6">
              <default-input
                v-model="stock.company_position"
                :placeholder="$t('input_placeholder.position_in_company')"
                name="company_position"
                required
                maxlength="150"
              />
            </div>
            <div class="col-12 col-sm-6">
              <default-input
                v-model="stock.name"
                :placeholder="$t('input_placeholder.your_name')"
                name="name"
                required
                maxlength="150"
              />
            </div>
            <div class="col-12 col-sm-6">
              <default-input
                v-model="stock.country"
                name="country"
                placeholder="Country"
                maxlength="150"
              />
            </div>
            <div class="col-12 col-sm-6">
              <default-input
                v-model="stock.email"
                :placeholder="$t('input_placeholder.e_mail_short')"
                name="email"
                type="email"
                required
                maxlength="150"
              />
            </div>
            <div class="col-12 col-sm-6">
              <phone-input
                v-model="stock.phone"
                required
                :placeholder="$t('input_placeholder.phone_number')"
              />
            </div>
            <div class="col-12 col-sm-6 clearance-stock-overstock_reason">
              <default-select
                as_input_type
                :empty_value_select_text="$t('input_placeholder.choose_overstock_reason')"
                :list_outer="reasons"
                :selected_val="stock.overstock_reason"
                @change="changeReason"
              />
            </div>
            <div class="col-12 col-sm-6">
              <default-input
                v-model="stock.product_type"
                name="product_type"
                maxlength="150"
                :placeholder="$t('input_placeholder.product_type')"
                required
              />
            </div>
          </div>
          <div class="mt-15"
               v-if="selected_other_reason">
            <default-input
              v-model="stock.overstock_reason_other"
              name="reason"
              :placeholder="$t('input_placeholder.reason')"
            />
          </div>
          <div class="row mt-15">
            <div class="col-12 col-sm-6">
              <label class="clearance-stock-form_top_inputs_number">
                <span class="clearance-stock-form_top_inputs_number_input">
                  <span @click="changeStockQuantity(stock.quantity - 1)" class="clearance-stock-form_top_inputs_number_input_decrement">–</span>
                  <input class="clearance-stock-form_top_inputs_number_input_quantity"
                         required
                         ref="stock_quantity"
                         type="number"
                         min="0"
                         :max="max_quantity"
                         :style="{width: stock.quantity > 100 ? '60px' : ''}"
                         :value="stock.quantity"
                         @input="changeQuantity">
                  <span @click="changeStockQuantity(stock.quantity + 1)" class="clearance-stock-form_top_inputs_number_input_increment">+</span>
                </span>
                <span class="clearance-stock-form_top_inputs_number_label">
                  {{ $t('input_placeholder.quantity_pallets') }}
                </span>
              </label>
            </div>
            <div class="col-12 col-sm-6">
              <label class="clearance-stock-form_top_inputs_file">
                <input id="file-input"
                       class="clearance-stock-form_input clearance-stock-form_products_catalogue"
                       placeholder="Add products catalogue"
                       type="file"
                       @change="addFile($event)"
                       ref="inputFile">

                <label for="file-input" class="clearance-stock-form_top_inputs_file_label">
                  <div>
                    <img src="/images/icons/attach.svg" alt="attach" class="clearance-stock-form_top_inputs_file_icon">
                  </div>
                  <div class="clearance-stock-form_top_inputs_file_filename">
                    <span v-if="!filename"> {{ $t('input_placeholder.add_products_catalogue') }}</span>
                    <span v-else>{{ filename }}</span>
                    <span class="clearance-stock-form_top_inputs_file_filetypes">{{
                        upload_error
                      }}(PDF, XLS, DOC)</span>
                  </div>
                </label>
              </label>
            </div>
            <div class="col-12 mt-10">
              <label class="terms-checkbox">
                <input required type="checkbox"
                       :value="agreeded"
                       v-model="agreeded"
                       @input="$emit('input', $event.target.checked)">
                <span v-html="`${$t('text.terms')}*`"/>
              </label>
            </div>
            <div class="col-12">
              <default-button type="submit" class="clearance-stock-form_button">{{ $t('btn.submit') }}</default-button>
            </div>
          </div>
        </form>
        <form-submitting-popup
          ref="form_submitting_modal"
          :title="$t('text.clearance_submit_title')"
          :body="$t('text.clearance_submit_text')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HtmlBlock from "../small_parts/HtmlBlock";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import DefaultButton from "../slots/DefaultButton.vue";
import {NEW_CLEARANCE_STOCK} from "../../helpers/new_objects";
import {axiosStock} from "../../helpers/axios_requests";
import LazyImage from "../small_parts/LazyImage.vue";
import DefaultSelect from "../small_parts/DefaultSelect.vue";
import DefaultInput from "../small_parts/DefaultInput.vue";
import PhoneInput from "../small_parts/PhoneInput.vue";
import ShapeHeadImageComponent from "../parts/ShapeHeadImageComponent.vue";
import FormSubmittingPopup from "../modals/FormSubmittingPopup.vue";
import TermsCheckbox from "../small_parts/TermsCheckbox.vue";

const OTHER_REASON = 'other'

export default {
  name: "ClearanceStockBlock",
  components: {
    TermsCheckbox,
    FormSubmittingPopup,
    ShapeHeadImageComponent,
    PhoneInput,
    DefaultInput,
    DefaultSelect,
    LazyImage,
    DefaultButton,
    DefaultTitle,
    HtmlBlock
  },
  props: {
    /**props**/
    content: {
      type: String,
      default: '',
      admin_type: 'editor',
    },
    title: {
      type: String,
      default: 'Do you have a clearance stock?',
      admin_type: 'input',
    },
    title_tag: {
      type: String,
      default: 'h1',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    /**props**/
  },
  computed: {
    selected_other_reason() {
      return (this.stock?.overstock_reason || '').toLowerCase() === OTHER_REASON
    }
  },
  data() {
    return {
      stock: [],
      reasons: [],
      agreeded: false,
      filename: null,
      upload_error: '',
      max_quantity: 9999
    }
  },
  beforeMount() {
    this.$set(this, 'stock', NEW_CLEARANCE_STOCK())
    this.getOverstockReasons()
  },
  methods: {
    getOverstockReasons() {
      axiosStock.reasons()
        .then(({data}) => {
          this.reasons = data.reasons;
        })
        .catch(e => {
          console.log(e.response.status);
        })
    },
    sendClearanceStock() {
      if (!this.agreeded) {
        alert(this.$t('text.agree_confirm'));
        return;
      }
      axiosStock.send(this.stock)
        .then(r => {
          this.showSubmittedModal()
          this.agreeded = false;
          this.stock = NEW_CLEARANCE_STOCK()
        })
        .catch(e => {
          console.log(e.response.status);
        })
    },
    addFile({target}) {
      this.upload_error = "";
      let file_name = target.files.length ? target.files[0].name : '';
      let allowedFiles = [".xlsx", ".xls", ".doc", ".docx", ".pdf"];
      if (!target.files.length || !allowedFiles.some(type => file_name.endsWith(type))) {
        this.upload_error = `${this.$t('input_placeholder.please_use_this_formats')}: `;
        target.value = null;
        this.$refs.inputFile.value = null
        this.filename = null
        this.stock.products_catalogue = ''
        return false;
      }

      if (target && target.files && target.files.length) {
        this.stock.products_catalogue = target.files[0];
        this.filename = file_name
      }
    },
    changeQuantity({target}) {
      let value = target.value || '0'
      this.changeStockQuantity(
        Number(value.replace(/\D/g, '')),
      )
    },
    changeStockQuantity(qty) {
      let change_input_val = false
      if (qty < 0) {
        change_input_val = true
        qty = 0;
      } else if (qty > this.max_quantity) {
        change_input_val = true
        qty = this.max_quantity
      }
      this.stock.quantity = qty;
      if (change_input_val) {
        this.$refs.stock_quantity.value = qty
      }
    },
    showSubmittedModal() {
      this.$refs.form_submitting_modal.openModal(true);
    },
    changeReason(value) {
      this.stock.overstock_reason = value
      if (!this.selected_other_reason) return
      this.stock.overstock_reason_other = ''
    },
  }
}
</script>
